import { Card, CardContent } from '@/components/ui/card';
import { GuidelineSection } from './guideline-text';
import { cn } from '@/lib/tailwind-utils';

export const GuidelineTable = (props: GuidelineSection) => {
  const { type, paymentDescription, extraDescription, hasSpaceBetween } = props;

  return (
    <Card className={cn('w-full rounded-none', { 'mb-6': hasSpaceBetween })}>
      <CardContent className="p-0">
        <div className="grid grid-cols-[1fr_3fr_3fr] border-collapse">
          <div className="border-r border-gray-300 p-2 align-top">
            <p>{type}</p>
          </div>
          <div className="p-2 align-top border-gray-300 border-r">{paymentDescription}</div>
          <div className="p-2 align-top">{extraDescription}</div>
        </div>
      </CardContent>
    </Card>
  );
};
